import {
  require_events
} from "./chunk-OQFX2AKS.mjs";
import {
  __toESM
} from "./chunk-DELDZXUX.mjs";

// packages/common/node-std/src/events.js
var import_events = __toESM(require_events());
var export_EventEmitter = import_events.EventEmitter;
export {
  export_EventEmitter as EventEmitter
};
//# sourceMappingURL=events.mjs.map
